import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media.js";
import Paw from "../../assets/images/paw-solid.png";


const ListItem = styled.li`
    width: 280px;
    box-sizing: content-box;
    border: 1px solid #fff;
    padding: 23px 50px 26px;
    text-align: left;
    cursor: url(${Paw}) 16 16, pointer;
    transition: 0.2s ease;
    border-radius: 5px;
    ${device.pc}{
        width: auto;
        padding: 23px 30px;
    }

    ${device.tablet}{
        box-sizing: border-box;
        width: 100%;
        padding: 3vw 5vw;
    }
    ${device.mobile}{
        width: 100%;
        padding: 2vw 5vw;
    }
    
    &:hover {
        border: 1px solid #f6ac19;
        background: #f6ac19;
        span {
            background-color: #fff;
            color: #f6ac19;
        }
    }
`;
const EnTitle = styled.span`
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    color: #fff;
    background-color: #f6ac19;
    font-size: 13px;
    
    text-transform: uppercase;
    font-weight: 500;
    
    ${device.tablet} {
        font-size: 14px;
    }
    ${device.mobile}{
        font-size: 12px;
        padding: 3px 10px;
    }
`;
const Title = styled.strong`
    display: block;
    padding-bottom: 6px;
    color: #fff;
    font-weight: 600;
    line-height: 27px;
    font-size: 22px;
    ${device.tablet}{
        line-height: 18px;
    }
    ${device.mobile}{
        font-size: 18px;
        letter-spacing: -0.5px;
        line-height: 18px;
    }
`;
const Desc = styled.p`
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    
    ${device.pc} {
        white-space: pre-line;
    }
    ${device.tablet}{
        padding-top: 5px;
    }
    ${device.mobile}{
        font-size: 12px;
    }
`;


const InfoBox = ({item}) => {
    const navigate = useNavigate();
    return (
        <ListItem
            key={item.title}
            onClick={() => navigate(item.link)}
        >
            <EnTitle>{item.en_title}</EnTitle>
            <Title>{item.title}</Title>
            <Desc>{item.description}</Desc>
        </ListItem>
    );
};

export default InfoBox;
